import React from "react";
//Limitless imports
import { useExpertMessageResponseContext } from "../expert-message-response/ExpertMessageResponseContext";
import { useExpertProfileContext } from "../expert-profile/ExpertProfileContext";
const INITIAL_STATE = {
  hasDismissed: false,
  hasSelected: false,
  selectedAnswer: null
};
export const useSuggestedAnswers = () => {
  const [saState, setSAState] = React.useState(INITIAL_STATE);
  const [suggestedAnswers, setSuggestedAnswers] = React.useState();
  const {
    profile
  } = useExpertProfileContext();
  const [showSuggestedAnswers, setShowSuggestedAnswers] = React.useState(profile.suggestedAnswerEnabled || true);
  React.useEffect(() => {
    setShowSuggestedAnswers(profile.suggestedAnswerEnabled);
  }, [profile.suggestedAnswerEnabled]);
  const {
    updateMessageResponse
  } = useExpertMessageResponseContext();
  const dismissAnswers = () => {
    setSAState({
      ...saState,
      hasDismissed: true
    });
    setShowSuggestedAnswers(false);
  };
  const selectAnswer = answer => {
    setSAState({
      ...saState,
      selectedAnswer: answer,
      hasSelected: true
    });
    updateMessageResponse(answer.body);
  };
  const clearSAState = () => {
    setSAState(INITIAL_STATE);
    setShowSuggestedAnswers(profile.suggestedAnswerEnabled || true);
  };
  return {
    showSuggestedAnswers,
    saState,
    suggestedAnswers,
    setSuggestedAnswers,
    dismissAnswers,
    selectAnswer,
    clearSAState
  };
};